import { ref, computed, watch } from "@vue/composition-api";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import store from "@/store";
import ability from "@/libs/acl/ability";
import { debounce } from "lodash";

export default function useList() {

  store.dispatch('user/getAll')
  const refListTable = ref(null);
  const toast = useToast();

  const tableColumns = [
    { label: "distribution_list.table_distribution.name", key: "name", sortable: true },
    { label: "distribution_list.table_distribution.users_count", key: "users_count", sortable: false },
    // { label: "distribution_list.table_distribution.emails", key: "emails", sortable: true },
  ];

  if (
    ability.can("create", "DistributionList") == true ||
    ability.can("update", "DistributionList") == true ||
    ability.can("delete", "DistributionList") == true
  ) {
    tableColumns.splice(0, 0, { label: "actions.name", key: "actions" });
  }

  const perPage = ref(10);
  const totalList = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref("");
  const sortBy = ref("name");
  const isSortDirDesc = ref(false);
  const userOptions = computed(() => store.getters['user/getItems'])
  // const isBusy = ref(false);

  const dataMeta = computed(() => {
    const localItemsCount = refListTable.value ? refListTable.value.localItems.length : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalList.value,
    };
  });

  const fetchList = (ctx, callback) => {
    // isBusy.value = true;

    store
      .dispatch("distribution_list/getAll", {
        q: searchQuery.value, // laravel
        max: perPage.value, // laravel
        "page[n]": currentPage.value, // laravel
        sortBy: sortBy.value, // laravel
        sortDesc: isSortDirDesc.value, // laravel
        withUsers: true,
        withEmails: true,
      })
      .then((response) => {
        const rows = response.data || response.items || response;
        const total = response.meta?.total || response.total || rows.length;
        callback(rows);
        totalList.value = total;
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: "Error obteniendo la información",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });

        callback([]);
      })
      .finally(() => {
        // isBusy.value = false;
      });
  };

  const refetchData = () => {
    refListTable.value.refresh();
  };

  watch([
    currentPage,
    perPage,
  ], () => {
    refetchData();
  });

  watch([ searchQuery ], debounce(() => { refetchData() }, 500))

  return {
    tableColumns,
    perPage,
    currentPage,
    totalList,
    fetchList,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refListTable,
    refetchData,
    userOptions,
    // isBusy,
  };
}
